import React, { useEffect } from 'react'
import { useStripeIntegration } from '../hooks'

const PricingTable = ({ userId }) => {
  const { loadStripePricingScript, createPricingTableElement } =
    useStripeIntegration()

  useEffect(() => {
    const cleanup = loadStripePricingScript()
    return cleanup
  }, [loadStripePricingScript])

  return React.createElement(
    'stripe-pricing-table',
    createPricingTableElement(userId)
  )
}

export default PricingTable
